import React, { useState } from 'react';
import { ref, uploadBytes, getDownloadURL, listAll } from 'firebase/storage';
import { storage } from '../firebaseConfig';
import Swal from 'sweetalert2';

export default function FirebaseStorageTest() {
  const [uploading, setUploading] = useState(false);
  const [files, setFiles] = useState<string[]>([]);

  const testConnection = async () => {
    try {
      const testRef = ref(storage, 'test/');
      const result = await listAll(testRef);
      
      Swal.fire({
        icon: 'success',
        title: '✅ Conexión exitosa',
        text: `Firebase Storage conectado. Carpetas encontradas: ${result.prefixes.length}`,
      });
    } catch (error: any) {
      console.error('Error de conexión:', error);
      Swal.fire({
        icon: 'error',
        title: '❌ Error de conexión',
        html: `
          <p><strong>Error:</strong> ${error.code}</p>
          <p><strong>Mensaje:</strong> ${error.message}</p>
          <p><strong>Posibles causas:</strong></p>
          <ul style="text-align: left;">
            <li>Reglas de Storage no configuradas</li>
            <li>Storage no habilitado en Firebase Console</li>
            <li>Configuración incorrecta de storageBucket</li>
          </ul>
        `,
      });
    }
  };

  const testUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    
    try {
      const timestamp = Date.now();
      const fileRef = ref(storage, `test/${timestamp}_${file.name}`);
      
      console.log('Subiendo archivo:', file.name, 'a:', fileRef.fullPath);
      
      const snapshot = await uploadBytes(fileRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      console.log('Archivo subido exitosamente:', downloadURL);
      
      setFiles(prev => [...prev, downloadURL]);
      
      Swal.fire({
        icon: 'success',
        title: '🎉 Subida exitosa',
        html: `
          <p>Archivo subido correctamente</p>
          <p><strong>URL:</strong> <a href="${downloadURL}" target="_blank">Ver archivo</a></p>
        `,
      });
    } catch (error: any) {
      console.error('Error detallado de subida:', error);
      Swal.fire({
        icon: 'error',
        title: '❌ Error de subida',
        html: `
          <p><strong>Código:</strong> ${error.code}</p>
          <p><strong>Mensaje:</strong> ${error.message}</p>
          <p><strong>Archivo:</strong> ${file.name}</p>
          <p><strong>Tamaño:</strong> ${(file.size / 1024 / 1024).toFixed(2)}MB</p>
        `,
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="card">
        <div className="card-header">
          <h3>🔥 Firebase Storage - Prueba de Conectividad</h3>
        </div>
        <div className="card-body">
          <div className="row mb-4">
            <div className="col-md-6">
              <h5>1. Probar Conexión</h5>
              <button 
                className="btn btn-primary"
                onClick={testConnection}
              >
                <i className="fa fa-plug me-2"></i>
                Probar Conexión a Storage
              </button>
            </div>
            
            <div className="col-md-6">
              <h5>2. Probar Subida</h5>
              <input
                type="file"
                className="form-control mb-2"
                accept="image/*"
                onChange={testUpload}
                disabled={uploading}
              />
              {uploading && (
                <div className="text-info">
                  <i className="fa fa-spinner fa-spin me-2"></i>
                  Subiendo archivo...
                </div>
              )}
            </div>
          </div>

          <div className="mb-4">
            <h5>3. Información de Configuración</h5>
            <div className="bg-light p-3 rounded">
              <p><strong>Proyecto:</strong> {process.env.REACT_APP_FIREBASE_PROJECT_ID || 'ampi-riviera-system'}</p>
              <p><strong>Storage Bucket:</strong> ampi-riviera-system.firebasestorage.app</p>
              <p><strong>Región:</strong> us-central1 (por defecto)</p>
            </div>
          </div>

          {files.length > 0 && (
            <div>
              <h5>4. Archivos Subidos</h5>
              <div className="row">
                {files.map((url, index) => (
                  <div key={index} className="col-md-3 mb-3">
                    <div className="card">
                      <img 
                        src={url} 
                        alt={`Test ${index + 1}`}
                        className="card-img-top"
                        style={{ height: '150px', objectFit: 'cover' }}
                      />
                      <div className="card-body p-2">
                        <small>
                          <a href={url} target="_blank" rel="noopener noreferrer">
                            Ver original
                          </a>
                        </small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="mt-4">
            <h5>5. Pasos para solucionar problemas:</h5>
            <ol>
              <li><strong>Habilitar Storage:</strong> Ve a Firebase Console → Storage → Comenzar</li>
              <li><strong>Configurar reglas:</strong> Permitir lectura/escritura autenticada</li>
              <li><strong>Verificar bucket:</strong> Debe ser "ampi-riviera-system.firebasestorage.app"</li>
              <li><strong>Revisar permisos:</strong> Tu cuenta debe tener acceso al proyecto</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}